const types = [{
    name: 'Офис',
    genitiveName: 'Офиса',
    key: 'office',
}, {
    name: 'Здание',
    genitiveName: 'Здания',
    key: 'building',
}, {
    name: 'Торговая площадь',
    genitiveName: 'Торговой площади',
    key: 'shoppingArea',
}, {
    name: 'Помещение свободного назначения',
    genitiveName: 'Помещения свободного назначения',
    key: 'freeAppointmentObject',
}, {
    name: 'Производство',
    genitiveName: 'Производства',
    key: 'industry',
}, {
    name: 'Склад',
    genitiveName: 'Склада',
    key: 'warehouse',
}, {
    name: 'Гараж',
    genitiveName: 'Гаража',
    key: 'garage',
}, {
    name: 'Готовый бизнес',
    genitiveName: 'Готового бизнеса',
    key: 'business',
}, {
    name: 'Коммерческая земля',
    genitiveName: 'Коммерческой земли',
    key: 'commercialLand',
}];

// tslint:disable-next-line: no-default-export
export default types;

const typeCoworking = {
    name: 'Коворкинг',
    genitiveName: 'Коворкинга',
    key: 'coworking',
};

export const typesWithCoworking = [
  ...[types[0], typeCoworking],
  ...types.slice(1),
];

export const coworkingSubTypes = [{
    name: 'Отдельный офис',
    genitiveName: 'Отдельного офиса',
    key: 'office',
}, {
    name: 'Закреплённое рабочее место',
    genitiveName: 'Закреплённого рабочего места',
    key: 'fixedWorkplace',
    disabled: true,
}, {
    name: 'Незакреплённое рабочее место',
    genitiveName: 'Незакреплённого рабочего места',
    key: 'flexibleWorkplace',
    disabled: true,
}];

export const coworkingAnalyticSubTypes = {
  office: 'flexible_office',
  fixedWorkplace: 'fixed_workplace',
  flexibleWorkplace: 'unfixed_workplace',
  conferenceHall: 'conference_hall',
  meetingRoom: 'meeting_room',
};
